import { render, staticRenderFns } from "./mouse-guard.vue?vue&type=template&id=64a2510a&scoped=true&"
import script from "./mouse-guard.vue?vue&type=script&lang=js&"
export * from "./mouse-guard.vue?vue&type=script&lang=js&"
import style0 from "./mouse-guard.vue?vue&type=style&index=0&id=64a2510a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2510a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a2510a')) {
      api.createRecord('64a2510a', component.options)
    } else {
      api.reload('64a2510a', component.options)
    }
    module.hot.accept("./mouse-guard.vue?vue&type=template&id=64a2510a&scoped=true&", function () {
      api.rerender('64a2510a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sheets/mouse-guard.vue"
export default component.exports